import { z } from 'zod'

const Importo = z.string().regex(/^-?\d+(\.\d+)?$/)
const Mese = z.string().regex(/^(1[0-2]|[1-9])$/)
const PerMese = z.record(Mese, Importo)

/** La struttura interna della formula la verifica il motore (formulaDaJson). */
const Formula = z.looseObject({
  op: z.enum(['costante', 'lettura', 'rigo', 'somma', 'differenza', 'prodotto', 'seTipologia']),
})

export const SchemaFormulePersonalizzate = z.object({
  righi: z
    .array(
      z.object({
        quadro: z.enum(['J', 'L', 'M']),
        progr: z.number().int().min(1).max(12),
        numeroUtenze: z.number().int().min(0),
        formula: Formula,
      }),
    )
    .optional(),
  quadroM: z.object({ usiCommerciali: z.boolean(), numeroUtenze: z.number().int().min(1) }).optional(),
  perDifferenza: z.object({ quadro: z.enum(['C', 'E']), tipologia: z.string().min(1), formula: Formula }).optional(),
  meseInizioAttivita: z.number().int().min(1).max(12).optional(),
})

export const SchemaQuadroS = z.object({
  acconto: Importo.optional(),
  creditoInizio: Importo.optional(),
  debitoInizio: Importo.optional(),
  creditoUtilizzato: PerMese.optional(),
  versatoOverride: PerMese.optional(),
})

export const SchemaOverride = z.record(z.string(), z.record(z.string(), PerMese))

/** codIdStatoEsteroType dello XSD: codice ditta, codice fiscale, partita IVA o
 * sigla di uno stato estero. */
export const ID_ADM = /^([A-Z]{3}[0-9]{5}[A-Z]|[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]|[0-9]{11}|[A-Z]{2})$/
/** nonNegativeInteger13Type dello XSD. */
const KwhIntero = z.string().regex(/^\d{1,13}$/)

export const SchemaElenchi = z.object({
  N: z.array(z.object({ tipologia: z.number().int().min(1).max(4), id: z.string().regex(ID_ADM), kwh: KwhIntero })).optional(),
  T: z.array(z.object({ provenienza: z.number().int().min(1).max(5), id: z.string().regex(ID_ADM), kwh: KwhIntero })).optional(),
  perdite: Importo.optional(),
})
